import React from "react";
import { BaseViewWidget } from "../components/BaseViewWidget";
import { EmptyViewFieldPlaceholder } from "../components/EmptyViewFieldPlaceholder";

export default function SelectWidget(props) {
  var label = props.label,
      value = props.value,
      metadata = props.schema.metadata;

  return React.createElement(
    BaseViewWidget,
    { label: label, help: metadata.help },
    formatData(value, metadata.titleMap)
  );
}

function formatData(value, titleMap) {
  var selected = !!titleMap && titleMap.find(function (option) {
    return option.value == value;
  });
  if (selected) {
    return selected.name;
  }
  return React.createElement(EmptyViewFieldPlaceholder, null);
}